module.exports = __webpack_public_path__ + "img/shrngfengzhengbeimian@2x.1fd4d957.png";